module.exports = __webpack_public_path__ + "img/daily.edfe1e09.png";